import BaseApi from './BaseApi'

export default {
  async createSummary(data) {
    return await BaseApi.post('/site-safety-health-summaries/new', data)
  },
  
  async getSummary(params) {
    return await BaseApi.get('/site-safety-health-summaries', { params })
  },
  
  async searchSummaries(params) {
    return await BaseApi.get('/site-safety-health-summaries/search', { params })
  },
  
  async updateSummary(id, data) {
    return await BaseApi.post(`/site-safety-health-summaries/${id}/update`, data)
  },
  
  async deleteSummary(id) {
    return await BaseApi.post(`/site-safety-health-summaries/${id}/delete`)
  }
}
